<template>
    <v-container fluid class="grey lighten-5 fill-height pa-0 mb-0">
        <v-overlay :value="dLoading">
            <v-progress-circular indeterminate size="64"></v-progress-circular> Espere un momento por favor.
        </v-overlay>
        <v-row justify="center">
            <v-col cols="12" xl="12" class="pa-0 ma-0">
                <div class="d-flex align-center mb-2 bsp_header pa-2">
                    <v-icon dark size="38" class="ma-4">add_reaction</v-icon>
                    <div>
                        <h1 class="text-h4 font-weight-white text-uppercase tracking-tight">
                            Ficha de Visitante
                        </h1>
                    </div>
                </div>
                <v-form ref="refMain" lazy-validation>
                    <v-row class="px-2">            
                        <v-col cols="12" md="6" class="pl-4 pt-0">
                            <v-card class="pa-3 pb-0 rounded-xl elevation-2">
                                <div class="text-subtitle-1 font-weight-bold mb-6 primary--text d-flex align-center">
                                    <v-icon color="primary" left>assignment_ind</v-icon>
                                    Datos Personales
                                </div>                            
                                <v-row dense>
                                    <v-col cols="12" sm="5">
                                        <v-select label="* Tipo Documento" filled dense v-model="dAdmVisita.tipo_documento" :items="[{text: 'DNI', value: 1},{text: 'Carnet Extranjeria', value: 2}]" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="7">
                                        <v-form ref="refDni">
                                            <v-text-field ref="refNro" v-model="dAdmVisita.Dni" @click:append="fuDni()" @keyup.enter.prevent ="fuDni()" label="* Numero" prepend-inner-icon="credit_card" :append-icon="dAdmVisita.Dni.length>8 ? '' :'search'" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= cNroDocSizeMax) || 'El campo debe ser <= a '+cNroDocSizeMax+' caracteres.']" :maxlength="cNroDocSizeMax" type="number" filled dense counter></v-text-field>
                                        </v-form>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="dAdmVisita.AP" label="* Apellido Paterno" @input="dAdmVisita.AP = $event.toUpperCase()" prepend-inner-icon="person" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 40) || 'El campo debe ser menor de 40 caracteres.']" :maxlength="40" autocomplete="off" filled dense></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="dAdmVisita.AM" label="* Apellido Materno" @input="dAdmVisita.AM = $event.toUpperCase()" prepend-inner-icon="person" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 40) || 'El campo debe ser menor de 40 caracteres.']" :maxlength="40" autocomplete="off" filled dense></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="8" md="4">
                                        <v-text-field v-model="dAdmVisita.Nombres" label="* Nombres" @input="dAdmVisita.Nombres = $event.toUpperCase()" prepend-inner-icon="person" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 40) || 'El campo debe ser menor de 40 caracteres.']" :maxlength="40" autocomplete="off" filled dense></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-select v-model="dAdmVisita.Sexo" label="* Sexo" :items="['Femenino', 'Masculino']" prepend-inner-icon="transgender" :rules="[v => !!v || 'El campo es requerido']" filled dense></v-select>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-menu
                                            v-model="dFechaMenu"
                                            :close-on-content-click="false"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                        >
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-text-field
                                                v-model="dFecha"
                                                label="F. Nacimiento"
                                                prepend-inner-icon="event"
                                                readonly
                                                filled dense
                                                v-bind="attrs"
                                                v-on="on"
                                                :messages="cEdadLabel"
                                                ></v-text-field>
                                            </template>
                                            <v-date-picker
                                                v-model="dFecha"
                                                :max="cFNacimientoMax"
                                                @input="dFechaMenu = false"
                                                no-title
                                            ></v-date-picker>
                                        </v-menu>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-select v-model="dAdmVisita.estadoCivil" label="* Estado Civil" :items="['CASADO','DIVORCIADO','SOLTERO','VIUDO']" prepend-inner-icon="wc" :rules="[v => !!v || 'El campo es requerido']" filled dense></v-select>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="12">
                                        <v-text-field v-model="dAdmVisita.Direccion" label="Dirección - Referencia" prepend-inner-icon="location_on" :maxlength="80" autocomplete="off" filled dense></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete
                                            v-model="dAdmVisita.IdUbigeo" label="Ubigeo de Referencia (Depa/Prov/Dist)"
                                            :items=dUbigeos
                                            filled dense clearable prepend-inner-icon="location_on">
                                        </v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete
                                            v-model="dAdmVisita.IdUbigeoOrigen" label="Ubigeo de Origen (Depa/Prov/Dist)"
                                            :items=dUbigeos
                                            filled dense prepend-inner-icon="location_on">
                                        </v-autocomplete>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <v-card class="pa-3 mt-3 pb-0 rounded-xl elevation-2" filled>
                                <div class="text-subtitle-1 font-weight-bold mb-6 primary--text d-flex align-center">
                                    <v-icon color="primary" left>contact_phone</v-icon> Contacto
                                </div>
                                <v-row dense>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="dAdmVisita.Celular" label="* Celular 1" filled dense prepend-inner-icon="smartphone" :rules="[v => !!v || 'El campo es requerido', v => (v && v.length <= 9) || 'El campo debe ser menor de 9 caracteres.']" :maxlength="9" autocomplete="off"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="dAdmVisita.Telefono" label="Celular 2" filled dense prepend-inner-icon="phone" :maxlength="10" autocomplete="off"></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-text-field v-model="dAdmVisita.Email" label="Correo Electrónico" filled dense prepend-inner-icon="email" :maxlength="100" autocomplete="off"></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-card>
                        </v-col>
                        <v-col cols="12" md="6" class="pr-4 pt-0">
                            <v-card class="pa-3 pb-0 rounded-xl elevation-2 mb-3">
                                <div class="text-subtitle-1 font-weight-bold mb-6 primary--text d-flex align-center">
                                    <v-icon color="primary" left>school</v-icon> Datos Académicos
                                </div>
                                <v-row dense>
                                    <v-col cols="12" sm="12">
                                        <v-autocomplete v-model="dAdmVisita.IdServicio" label="* Carrera Profesional"
                                                            :items="ssPriServiciosIngreso" item-value="IdServicio" item-text="Descripcion2"
                                                            filled dense prepend-inner-icon="bookmark" :rules="[v => !!v || 'El campo es requerido']"></v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="8">
                                        <v-autocomplete v-model="dAdmVisita.IdServicio2" label="Segunda Carrera Profesional"
                                                            :items="ssPriServiciosIngreso"  item-value="IdServicio" item-text="Descripcion2"
                                                            filled dense prepend-inner-icon="bookmark"></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="4">
                                        <v-select v-model="dAdmVisita.Turno" label="Turno de preferencia"
                                                        :items="['Mañana', 'Tarde', 'Noche']"
                                                        filled dense prepend-inner-icon="brightness_4" :rules="[v => !!v || 'El campo es requerido']"></v-select>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="4">
                                        <v-select v-model="dAdmVisita.ModalidadAsistencia" label="* Modalidad"
                                            :items="['Presencial', 'Virtual', 'Semipresencial']" filled dense prepend-inner-icon="local_library" :rules="[v => !!v || 'El campo es requerido']">
                                        </v-select>
                                    </v-col>
                                    <v-col cols="12" sm="8">
                                        <v-select v-model="dAdmVisita.Quien" label="* ¿Quien eligió el lugar donde estudiar?"
                                            :items="['Yo', 'Mis Padres', 'Mis Hermanos', 'Mis Familiares', 'Otros']" filled dense prepend-inner-icon="contact_support" :rules="[v => !!v || 'El campo es requerido']">
                                        </v-select>
                                    </v-col>
                                </v-row>
                                <v-row dense>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete v-model="dIdMedios1" label="* ¿Cómo se enteró de nosotros?"
                                            :items="[{text: 'Publicidad - Afiches', value: 7},
                                                    {text: 'Publicidad - Redes sociales', value: 9},
                                                    {text: 'Publicidad - Periódico', value: 8},
                                                    {text: 'Publicidad - Radio', value: 1},
                                                    {text: 'Publicidad - Televisión', value: 2},
                                                    {text: 'Publicidad - Vallas', value: 24},
                                                    {text: 'Publicidad - Visitas/Charlas', value: 13},
                                                    {text: 'Publicidad - Volantes', value: 10}]"
                                            :rules="[v => !!v || 'El campo es requerido']" prepend-inner-icon="campaign" filled dense multiple chips clearable
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-autocomplete v-model="dIdMedios2" label="* ¿Por qué nos elegiste?"
                                            :items="[{text: 'Prestigio - Prestigio', value: 6},
                                                    {text: 'Prestigio - Reconocimiento a la calidad educativa', value: 23},
                                                    {text: 'Prestigio - Ubicación/Cercanía', value: 14},
                                                    {text: 'Referencia - Amigos', value: 11},
                                                    {text: 'Referencia - Docentes', value: 3},
                                                    {text: 'Referencia - Estudiantes', value: 4},
                                                    {text: 'Referencia - Familiares', value: 12},
                                                    {text: 'Referencia - Trabajadores', value: 5}]"
                                            :rules="[v => !!v || 'El campo es requerido']" prepend-inner-icon="thumb_up" filled dense multiple chips clearable
                                        ></v-autocomplete>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <v-card v-if="dAdmVisitas.length>0" class="pa-0 mb-0 rounded-xl elevation-2">
                                <v-row dense>
                                    <v-col cols="12" sm="6" class="pa-0 pl-5 pb-1">
                                        <v-list dense>
                                            <v-subheader class="text-subtitle-1 font-weight-bold mb-2 primary--text d-flex align-center"><v-icon color="primary" left>manage_history</v-icon> VISITANTE</v-subheader>
                                            <v-list-item-group color="primary">
                                                <v-list-item v-for="(item, i) in dAdmVisitas" :key="i">
                                                    <v-list-item-action class="pr-1 ma-0">
                                                        <v-chip :color="fuServicioInicialColor(item.priservicio.Iniciales)" outlined>{{item.priservicio.Iniciales}}</v-chip>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{item.Visitante}}</v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            <v-icon size="20" color="blue">credit_card</v-icon>{{item.priservicio.Descripcion}}
                                                        </v-list-item-subtitle>
                                                        <v-list-item-subtitle>
                                                            <v-icon size="20" color="blue">event</v-icon>{{item.Fecha.substring(0, 16)}} <v-icon size="20" color="blue">person</v-icon>{{item.Operador}}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list-item-group>
                                        </v-list>
                                    </v-col>
                                    <v-col cols="12" sm="6" class="pa-0 pl-5 pb-1">
                                        <v-list dense>
                                            <v-subheader class="text-subtitle-1 font-weight-bold mb-2 primary--text d-flex align-center"><v-icon color="primary" left>manage_history</v-icon> ALUMNO</v-subheader>
                                            <v-list-item-group color="primary">
                                                <v-list-item v-for="(item, i) in dPriAlumnos" :key="i">
                                                    <v-list-item-action class="pr-1 ma-0">
                                                        <v-chip :color="fuServicioInicialColor(item.priservicio.Iniciales)" outlined>{{item.priservicio.Iniciales}}</v-chip>
                                                    </v-list-item-action>
                                                    <v-list-item-content>
                                                        <v-list-item-title>{{item.Alumno}}</v-list-item-title>
                                                        <v-list-item-subtitle>
                                                            <v-icon size="20" color="blue">code</v-icon>{{item.Codigo}}
                                                            <v-icon size="20" color="blue">credit_card</v-icon>{{item.priservicio.Descripcion}}
                                                        </v-list-item-subtitle>
                                                        <v-list-item-subtitle>
                                                            <v-icon size="20" color="blue">event</v-icon>{{item.FechaCreacion.substring(0, 16)}} <v-icon size="20" color="blue">person</v-icon>{{item.operador}}
                                                        </v-list-item-subtitle>
                                                    </v-list-item-content>
                                                </v-list-item>
                                            </v-list-item-group>
                                        </v-list>
                                    </v-col>
                                </v-row>
                            </v-card>
                            <div class="d-flex justify-end mt-2">
                                {{ssUser.Usuario}}
                                <v-btn @click.prevent="fuResetForm" color="grey lighten-2" class="mr-5 px-10 text-none" elevation="0" large>
                                    <v-icon left>clear</v-icon> Cancelar
                                </v-btn>
                                <v-btn @click.prevent="fuVisitaSave" :loading="dLoading" color="primary" class="px-12 text-none" elevation="6" large>
                                    <v-icon left>save</v-icon> Registrar Visitante
                                </v-btn>
                            </div>
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
        <v-snackbar v-model="dSnackbar" color="red">Revise el formulario, existe datos erróneos.
            <v-btn text @click="dSnackbar = false"> Cerrar </v-btn>
        </v-snackbar>
    </v-container>
</template>
<script>
import moment from 'moment';
import gql from 'graphql-tag';
import {mapState} from 'vuex';
import 'sweetalert2/src/sweetalert2.scss';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { dUbigeos } from '@/helpers/ubigeos.js';
import {fuServicioInicialColor} from '@/helpers/index.js';

const getInitialData = () => ({
    AP: '',
    AM: '',
    Nombres: '',
    Quien: '',
    Telefono: '',
    Email: '',
    IdServicio: null,
    Sexo: 'Femenino',
    Edad: 0,
    Modalidad: 'Admisión',
    Turno: 'Mañana',
    Condicion: 'Inscrito',
    FechaReserva: '',
    Fecha: '',
    Departamento: '',
    Provincia: '',
    Distrito: '',
    FrecuenciaVisita: 1,
    Operador: 'web',
    Celular: '',
    ModalidadAsistencia: 'Presencial',
    Direccion: '',
    Dni: '',//74053112
    vSexo: 'F',
    FecNac: '',
    FecReg: '',
    FecMod: '',
    IdUbigeo: '',
    IdServicio2: null,
    IdUbigeoOrigen: '',
    tipo_documento:1,
    estadoCivil: 'SOLTERO'
});

export default {
    name: 'VisitanteAdd',
    mounted(){
        this.$nextTick(() => this.$refs.refNro.focus());
        if(this.ssUser) this.dAdmVisita.Operador=this.ssUser.Usuario
    },
    data: () => ({
        dFechaMenu: false,
        dFecha: '',
        dIdMedios1: null,
        dIdMedios2: null,
        dLoading: false,
        dAdmVisita: getInitialData(),
        dUbigeos: dUbigeos,
        dSnackbar: false,
        dPriAlumnos: [],
        dAdmVisitas: [],
    }),
    watch: {
        'dAdmVisita.Sexo' (val) {
            if(val != '' && val)
                this.dAdmVisita.vSexo = val.substring(0,1);
        },
        dFecha(val) {
            if (val) {
                this.dAdmVisita.FecNac = val.split("-").join("");
                this.dAdmVisita.Edad = moment().diff(val, 'years');
            }
        },
        'dAdmVisita.IdUbigeo' (val) {
            if(val != '' && val){
                for(var item of this.dUbigeos){
                    if(val==item.value){
                        let vUbigeo = item.text.split("/");
                        this.dAdmVisita.Departamento = vUbigeo[0];
                        this.dAdmVisita.Provincia = vUbigeo[1];
                        this.dAdmVisita.Distrito = vUbigeo[2];
                    }
                }
            }
        },
    },
    computed: {
        ...mapState(['ssUser', 'ssPriServiciosIngreso']),
        cEdadLabel() {
            return this.dAdmVisita.Edad > 0 ? `Edad calculada: ${this.dAdmVisita.Edad} años` : '';
        },
        cNroDocSizeMax () {
            return this.dAdmVisita.tipo_documento == 1 ? 8 : 12;
        },
        cFNacimientoMax () {
            return moment().subtract(15,'years').format("YYYY-MM-DD");
        }
    },
    methods: {
        fuServicioInicialColor,
        save (date) {
            this.$refs.menu.save(date)
        },
        async fuDni() {
            if(this.$refs.refDni.validate()){
                this.dLoading = true;
                this.dPriAlumnos = [];
                this.dAdmVisitas = [];
                try {
                    const response = await this.$apollo.query({
                        query: gql`query consulta($dni: String!, $UsuarioCreacion: String){
                            pripersonareniecBydni(dni: $dni, UsuarioCreacion: $UsuarioCreacion){
                                data
                            }
                            prialumnoByDNI(DNI: $dni){
                                IdAlumno
                                Alumno
                                Codigo
                                FechaCreacion
                                operador
                                priservicio{
                                    Iniciales
									Descripcion
                                }
                            }
                            admvisitaByDni(Dni: $dni){
                                idVisitas
                                Visitante
                                Fecha
                                Operador
                                priservicio{
                                    Iniciales
                                    Descripcion
                                }
                            }
                        }`,
                        variables: {
                            dni: this.dAdmVisita.Dni,
                            UsuarioCreacion: this.ssUser.Usuario,
                        }
                    })
                    const persona = JSON.parse(response.data.pripersonareniecBydni.data);
                    const alumnos = response.data.prialumnoByDNI || [];
                    this.dPriAlumnos = alumnos.slice().sort((a, b) => {
                        const fechaA = new Date(a.FechaCreacion);
                        const fechaB = new Date(b.FechaCreacion);
                        return fechaB - fechaA;
                    });
                    const visitantes = response.data.admvisitaByDni || [];
                    this.dAdmVisitas = visitantes.slice().sort((a, b) => {
                        const fechaA = new Date(a.Fecha);
                        const fechaB = new Date(b.Fecha);
                        return fechaB - fechaA;
                    });

                    if (persona) {
                        console.log(persona);
                        
                        this.dAdmVisita.AP = persona.ap_paterno;
                        this.dAdmVisita.AM = persona.ap_materno;
                        this.dAdmVisita.Nombres = persona.nombres;
                        this.dAdmVisita.Sexo = persona.sexo;
                        this.dAdmVisita.Direccion = persona.direccion;
                        this.dAdmVisita.estadoCivil = persona.estadoCivil;
                        
                        if (persona.fecha_nacimiento) {
                            this.dFecha = persona.fecha_nacimiento.substring(0, 10);
                        }
                        
                        const ubigeoEncontrado = this.dUbigeos.find(item => item.text === persona.ubigeotext.trim());
                        const codUbigeo = ubigeoEncontrado ? ubigeoEncontrado.value : null;
                        this.dAdmVisita.IdUbigeo = codUbigeo;
                        this.dAdmVisita.IdUbigeoOrigen = codUbigeo;
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    this.dLoading = false;
                }
            }
        },
        fuResetForm() {
            this.dAdmVisita = getInitialData();
            this.dFecha = '';
            this.$refs.refMain.resetValidation();
            this.dPriAlumnos = [];
            this.dAdmVisitas = [];
        },
        fuVisitaSave () {
            if(!this.$refs.refMain.validate() || !this.$refs.refDni.validate() || this.dAdmVisita.Dni=="" || ((this.dAdmVisita.tipo_documento==1 && this.dAdmVisita.Dni.length>8)||(this.dAdmVisita.tipo_documento==2 && this.dAdmVisita.Dni.length>12))){
                this.dSnackbar = true;
            } else {
                this.dAdmVisita.FechaReserva = this.dAdmVisita.Fecha = this.dAdmVisita.FecReg = this.dAdmVisita.FecMod = moment().format("YYYYMMDD HH:mm:ss");
                this.fuVisitaCreate();
            }
        },
        async fuVisitaCreate () {
            try {
                this.dLoading = true;
                const response = await this.$apollo.mutate({
                    mutation: gql`mutation admvisitaCreateIdMedios($input: admvisitaCreateInput!, $IdMedios: String){
                        admvisitaCreateIdMedios(input: $input, IdMedios: $IdMedios){
                            idVisitas
                        }
                    }`,
                    variables: {
                        input: this.dAdmVisita,
                        IdMedios: `${this.dIdMedios1},${this.dIdMedios2}`
                    }
                });
                if(response.data.admvisitaCreateIdMedios){
                    Swal.fire({
                        icon: 'success',
                        title: 'Felicitaciones',
                        html: 'Se registró como Visitante.<br>' +
                            '<b>¿Desea continuar y registrar como postulante?</b>',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Si, ir a Postulante',
                        cancelButtonText: 'No',
                        allowOutsideClick: false,
                    }).then((result) => {
                        if (result.value)
                            this.$router.push(`/Admision/${response.data.admvisitaCreateIdMedios.idVisitas}/Postulante`);
                        else{
                            this.fuResetForm();
                        }
                    })
                } else {
                    console.log("No se guardo.");
                    Swal.fire('¡ ERROR !', 'No se guardó el visitante.', 'error');
                }
            } catch (error) {
                console.log(error);
                Swal.fire({
                        icon: 'error',
                        title: '¡ ERROR !',
                        html: 'No se guardó, intente de nuevo.'
                    })
            } finally {
                this.dLoading = false;
            }
        },
    }
}
</script>
<style scoped>
    .bsp_header {
        background: linear-gradient(130deg, transparent 0% 87%, rgba(255, 255, 255, .6) 87.1% 100%),
                    linear-gradient(130deg, transparent 0% 75%, rgba(255, 255, 255, .4) 75.1% 100%),
                    linear-gradient(90deg, transparent 0% 35%, rgba(255, 255, 255, .3) 65.1% 100%),
                    linear-gradient(130deg, transparent 0% 60%, rgba(255, 255, 255, .2) 60.1% 100%),
                    linear-gradient(90deg, #3498db 0%, #2980b9 100%); /* Color base reemplazando var(--headerPrimary) */
        color: white;
    }
</style>